import { createMemoStyles, safeRest, clsx, getDisplayName, uniqueId, defaultFonts, clearfix, defaultBaseline, isBrowser, withNested, guardElement } from '@wds/utils';
import React, { useState, useEffect, useRef, useImperativeHandle, Children, useMemo, isValidElement, cloneElement } from 'react';
import { createPortal } from 'react-dom';
import { useTheme } from 'react-jss';
import { Slide } from '@wds/motion';
import PropTypes from 'prop-types';
import { IconX } from '@wds/icons';
import { Typography } from '@wds/typography';
var POPOUT_PLACEMENTS = ['top', 'bottom', 'right', 'left'];
var POPOUT_SIZES = ['lg', 'md', 'sm'];
var POPOUT_ALIGNMENS = ['left', 'right'];
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var useStyles$6 = createMemoStyles(function (theme) {
  var spacing = theme.spacing,
      type = theme.type,
      palette = theme.palette;
  return {
    wrenchPopoutBody: {
      fontFamily: type.fontFamily.base,
      '-webkit-font-smoothing': 'antialiased',
      padding: spacing[5],
      textAlign: 'left',
      fontSize: type.fontSize.bodySm,
      color: palette.text.dark
    }
  };
});

var PopoutBody = function (_a) {
  var children = _a.children,
      id = _a.id,
      props = __rest(_a, ["children", "id"]);

  var wrenchPopoutBody = useStyles$6().wrenchPopoutBody;
  return React.createElement("div", __assign({
    className: wrenchPopoutBody,
    id: id
  }, safeRest(props)), children);
};

PopoutBody.displayName = 'PopoutBody';

function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var objectWithoutProperties = {
  exports: {}
};
var objectWithoutPropertiesLoose = {
  exports: {}
};

(function (module) {
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  module.exports = _objectWithoutPropertiesLoose;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
})(objectWithoutPropertiesLoose);

(function (module) {
  var objectWithoutPropertiesLoose$1 = objectWithoutPropertiesLoose.exports;

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = objectWithoutPropertiesLoose$1(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  module.exports = _objectWithoutProperties;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
})(objectWithoutProperties);

var _objectWithoutProperties = /*@__PURE__*/getDefaultExportFromCjs(objectWithoutProperties.exports);

var defineProperty = {
  exports: {}
};

(function (module) {
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  module.exports = _defineProperty;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
})(defineProperty);

var _defineProperty = /*@__PURE__*/getDefaultExportFromCjs(defineProperty.exports);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var useStyles$5 = createMemoStyles(function (_ref) {
  var spacing = _ref.spacing,
      type = _ref.type;
  return {
    wrenchCloseButton: function wrenchCloseButton(_ref2) {
      var component = _ref2.component;
      var componentSpecificStyles = {
        badge: {
          position: 'relative',
          top: 'none',
          right: 'none',
          padding: 0,
          marginLeft: spacing[3]
        },
        banner: {
          position: 'absolute',
          top: spacing[2],
          right: spacing[2],
          padding: 0
        },
        alert: {
          padding: [spacing[2], 0, spacing[2], spacing[5]],
          textAlign: 'right'
        },
        default: {
          position: 'absolute',
          right: spacing[1],
          top: spacing[1],
          padding: spacing[2]
        }
      };
      return _objectSpread(_objectSpread({}, componentSpecificStyles[component || 'default']), {}, {
        fontSize: type.fontSize.body,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        borderRadius: '0',
        textDecoration: 'none',
        background: 'transparent',
        border: 'none',
        '&:hover': {
          transition: 'none',
          textDecoration: 'none'
        },
        '&:active': {
          transition: 'none',
          outline: 'none'
        }
      });
    }
  };
});
var _excluded = ["children", "component", "label", "onClick", "type", "variant"];

var CloseButton = function CloseButton(_ref) {
  _ref.children;
  var component = _ref.component,
      label = _ref.label,
      onClick = _ref.onClick;
  _ref.type;

  var variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();

  var _useStyles = useStyles$5({
    theme: theme,
    component: component
  }),
      wrenchCloseButton = _useStyles.wrenchCloseButton;

  return /*#__PURE__*/React.createElement("button", Object.assign({
    onClick: onClick,
    type: "button",
    className: wrenchCloseButton,
    "aria-label": label
  }, safeRest(rest)), /*#__PURE__*/React.createElement(IconX, {
    title: "close",
    color: variant
  }));
};

CloseButton.displayName = "CloseButton";
CloseButton.propTypes = {
  children: PropTypes.string,
  component: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string,
  variant: PropTypes.oneOf(['dark', 'light'])
};
CloseButton.defaultProps = {
  children: 'CloseButton',
  component: undefined,
  type: undefined,
  variant: 'light'
};
var CloseButton$1 = CloseButton;
var useStyles$4 = createMemoStyles(function (theme) {
  var spacing = theme.spacing,
      palette = theme.palette,
      radius = theme.radius,
      shadow = theme.shadow;
  var popout = {
    width: {
      sm: 275,
      md: 360,
      lg: 445
    },
    boxShadow: shadow.space,
    pipSize: 12,
    borderRadius: radius.small,
    border: 'none'
  };
  return {
    wrenchPopout: {
      boxSizing: 'border-box',
      zIndex: theme.elevation.space,
      position: 'absolute',
      outline: 'none',
      width: '80vw',
      whiteSpace: 'normal',
      left: '50%',
      bottom: '100%',
      textAlign: 'center',
      transform: 'translateY(-6px)',
      maxWidth: function (_a) {
        var size = _a.size;
        return popout.width[size];
      },
      marginLeft: function (_a) {
        var placement = _a.placement,
            size = _a.size;
        return ['top', 'bottom'].includes(placement) ? -(popout.width[size] / 2) : 'auto';
      }
    },
    wrenchPopoutPlacementTop: {
      left: '50%',
      bottom: '100%',
      textAlign: 'center',
      transform: 'translateY(-6px)',
      '& $wrenchPopoutPopout': {
        '&:after': {
          content: '""',
          bottom: -(popout.pipSize / 2),
          left: '50%',
          marginLeft: -(popout.pipSize / 2)
        }
      }
    },
    wrenchPopoutPlacementBottom: {
      left: '50%',
      top: '100%',
      textAlign: 'center',
      transform: 'translateY(6px)',
      '& $wrenchPopoutPopout': {
        '&:after': {
          content: '""',
          top: -(popout.pipSize / 2),
          left: '50%',
          marginLeft: -(popout.pipSize / 2),
          transform: 'rotate(-135deg)'
        }
      }
    },
    wrenchPopoutPlacementLeft: {
      right: '100%',
      transform: 'translate(0, -50%)',
      bottom: 'auto',
      top: '50%',
      left: 'auto',
      paddingBottom: 0,
      paddingRight: popout.pipSize + spacing[1],
      textAlign: 'right',
      marginTop: -(popout.pipSize / 2),
      marginLeft: '0 !important',
      '& $wrenchPopoutPopout': {
        '&:after': {
          content: '""',
          left: 'auto',
          right: -(popout.pipSize / 2),
          top: '50%',
          bottom: 'auto',
          transform: 'rotate(-45deg)'
        }
      }
    },
    wrenchPopoutPlacementRight: {
      left: '100%',
      transform: 'translate(0, -50%)',
      bottom: 'auto',
      top: '50%',
      paddingLeft: popout.pipSize + spacing[1],
      paddingBottom: 0,
      textAlign: 'left',
      marginTop: -(popout.pipSize / 2),
      marginLeft: '0 !important',
      '& $wrenchPopoutPopout': {
        '&:after': {
          content: '""',
          left: -(popout.pipSize / 2),
          top: '50%',
          marginLeft: 0,
          bottom: 'auto',
          transform: 'rotate(135deg)'
        }
      }
    },
    wrenchPopoutPopout: {
      background: palette.background.light,
      borderRadius: popout.borderRadius,
      boxShadow: popout.boxShadow,
      position: 'relative',
      border: popout.border,
      '&:after': {
        content: '',
        position: 'absolute',
        width: popout.pipSize,
        height: popout.pipSize,
        backgroundColor: palette.background.light,
        transform: 'rotate(45deg)',
        boxShadow: ['3px', '3px', '5px', 'rgba(0, 0, 0, 0.07)']
      }
    }
  };
});
var PLACEMENT_TO_SLIDE = {
  top: 'up',
  bottom: 'down',
  right: 'right',
  left: 'left'
};
var PLACEMENT_TO_CLASSNAME = {
  top: 'wrenchPopoutPlacementTop',
  bottom: 'wrenchPopoutPlacementBottom',
  right: 'wrenchPopoutPlacementRight',
  left: 'wrenchPopoutPlacementLeft'
};
var PopoutContent = React.forwardRef(function (_a, ref) {
  var children = _a.children,
      _b = _a.clickable,
      clickable = _b === void 0 ? false : _b,
      _c = _a.closeButtonLabel,
      closeButtonLabel = _c === void 0 ? 'Close Popout' : _c,
      _d = _a.noCloseButton,
      noCloseButton = _d === void 0 ? false : _d,
      _e = _a.hasRenderTo,
      hasRenderTo = _e === void 0 ? false : _e,
      _f = _a.size,
      size = _f === void 0 ? 'sm' : _f,
      title = _a.title,
      _g = _a.placement,
      placement = _g === void 0 ? 'top' : _g,
      _h = _a.show,
      show = _h === void 0 ? false : _h,
      handleClose = _a.handleClose,
      popoutStyle = _a.popoutStyle;

  var _j = useStyles$4({
    size: size,
    placement: placement
  }),
      wrenchPopout = _j.wrenchPopout,
      wrenchPopoutPopout = _j.wrenchPopoutPopout,
      wrenchPlacementClasses = __rest(_j, ["wrenchPopout", "wrenchPopoutPopout"]);

  var popoutClassNames = clsx(wrenchPopout, wrenchPlacementClasses[PLACEMENT_TO_CLASSNAME[placement]]);

  var _k = useState({}),
      style = _k[0],
      setStyle = _k[1];

  useEffect(function () {
    setStyle(popoutStyle && {
      left: popoutStyle.left,
      top: popoutStyle.top,
      zIndex: popoutStyle.zIndex,
      position: popoutStyle.position
    } || {});
  }, [popoutStyle]); // Forward information about box up to Popout component

  var contentRef = useRef(null); // Clean up what we send back to the parent.

  useImperativeHandle(ref, function () {
    var _a, _b;

    return {
      childBoundingBox: (_b = (_a = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) === null || _a === void 0 ? void 0 : _a.children[0]) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()
    };
  });
  var childArray = Children.toArray(children);
  var hasMasthead = childArray.find(function (child) {
    return getDisplayName(child) === 'PopoutMasthead';
  });
  var hasHeader = childArray.some(function (child) {
    return getDisplayName(child) === 'PopoutHeader';
  }); // Close button can't be removed if the buton is clickable. This is to give the user an easy way to remove the popout.

  var isCloseButtonOverridden = noCloseButton && !clickable; // Close button won't show up for masthead popouts even if it's clickable

  var hasCloseButton = !hasMasthead && !isCloseButtonOverridden; // Ids for labels and children

  var headerId = hasHeader && uniqueId('wds-popout-header-') || undefined;
  var bodyId = useMemo(function () {
    return uniqueId('wds-popout-body-');
  }, []);
  return React.createElement("div", {
    role: "dialog",
    "aria-labelledby": headerId,
    "aria-describedby": bodyId,
    "aria-label": title,
    className: popoutClassNames,
    style: style,
    ref: contentRef
  }, React.createElement(Slide, {
    in: show,
    direction: PLACEMENT_TO_SLIDE[placement],
    timeout: !clickable && !show && hasRenderTo ? 0 : 150,
    distance: "near"
  }, React.createElement("div", null, React.createElement("div", {
    className: wrenchPopoutPopout
  }, hasCloseButton && React.createElement(CloseButton$1, {
    onClick: handleClose,
    label: closeButtonLabel,
    variant: "dark"
  }), Children.map(children, function (child) {
    if (isValidElement(child)) {
      var displayName = getDisplayName(child); // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment

      var props = __assign({
        id: displayName === 'PopoutHeader' ? headerId : bodyId
      }, child.props); // eslint-disable-next-line @typescript-eslint/no-unsafe-argument


      return cloneElement(child, __assign({}, props));
    }

    return undefined;
  })))));
});
var useStyles$3 = createMemoStyles(function (theme) {
  var spacing = theme.spacing;
  return {
    wrenchPopoutFooter: __assign(__assign(__assign({}, defaultFonts(theme)), {
      padding: spacing[5],
      paddingTop: 0,
      margin: 0
    }), clearfix),
    wrenchPopoutAlign: function (_a) {
      var align = _a.align;
      return align && {
        right: {
          display: 'flex',
          flexGrow: 1,
          flexWrap: 'wrap',
          justifyContent: 'flex-end',
          '& [class*="wrenchButton-"]': {
            marginLeft: spacing[2]
          }
        },
        left: {
          display: 'flex',
          flexGrow: 1,
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          '& [class*="wrenchButton-"]': {
            marginRight: spacing[2]
          }
        }
      }[align] || undefined;
    }
  };
});

var PopoutFooter = function (_a) {
  var align = _a.align,
      children = _a.children,
      props = __rest(_a, ["align", "children"]);

  var _b = useStyles$3({
    align: align
  }),
      wrenchPopoutFooter = _b.wrenchPopoutFooter,
      wrenchPopoutAlign = _b.wrenchPopoutAlign;

  return React.createElement("footer", __assign({}, safeRest(props), {
    className: wrenchPopoutFooter
  }), React.createElement("div", {
    className: wrenchPopoutAlign
  }, children));
};

PopoutFooter.displayName = 'PopoutFooter';
var useStyles$2 = createMemoStyles(function (_a) {
  var spacing = _a.spacing,
      type = _a.type;
  return {
    wrenchPopoutHeader: __assign(__assign({}, defaultFonts({
      type: type
    })), {
      padding: spacing[5],
      paddingBottom: 0,
      textAlign: 'left',
      '& + [class*="wrenchPopoutBody"]': {
        paddingTop: spacing[4]
      }
    }),
    wrenchPopoutHeaderText: {
      fontWeight: type.fontWeight.medium
    }
  };
});

var PopoutHeader = function (_a) {
  var children = _a.children,
      id = _a.id,
      props = __rest(_a, ["children", "id"]);

  var _b = useStyles$2(),
      wrenchPopoutHeader = _b.wrenchPopoutHeader,
      wrenchPopoutHeaderText = _b.wrenchPopoutHeaderText;

  return React.createElement("header", __assign({
    className: wrenchPopoutHeader,
    id: id
  }, safeRest(props)), React.createElement(Typography, {
    component: "h2",
    variant: "body"
  }, React.createElement("div", {
    className: wrenchPopoutHeaderText
  }, children)));
};

PopoutHeader.displayName = 'PopoutHeader';
var useStyles$1 = createMemoStyles(function (theme) {
  var palette = theme.palette;
  return {
    wrenchPopoutMasthead: __assign(__assign({}, defaultFonts(theme)), {
      height: '150px',
      background: palette.info.main,
      overflow: 'hidden',
      '> img': {
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        margin: 0,
        display: 'block'
      }
    })
  };
});

var PopoutMasthead = function (_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  var wrenchPopoutMasthead = useStyles$1().wrenchPopoutMasthead;
  return React.createElement("div", __assign({
    className: wrenchPopoutMasthead
  }, safeRest(props)), children);
};

PopoutMasthead.displayName = 'PopoutMasthead';

var getNewPosition = function (_a) {
  var width = _a.width,
      height = _a.height,
      popoutRect = _a.popoutRect,
      childRect = _a.childRect,
      placement = _a.placement,
      autoFlip = _a.autoFlip,
      pipSize = _a.pipSize;
  var newPlacement = placement;
  var availablePlacementSpace = [{
    placement: 'top',
    width: width,
    height: popoutRect.top,
    area: width * popoutRect.top
  }, {
    placement: 'right',
    width: width - popoutRect.right,
    height: height,
    area: (width - popoutRect.right) * height
  }, {
    placement: 'bottom',
    width: width,
    height: height - popoutRect.bottom,
    area: width * (height - popoutRect.bottom)
  }, {
    placement: 'left',
    width: popoutRect.left,
    height: height,
    area: popoutRect.left * height
  }].sort(function (a, b) {
    return b.area - a.area;
  });
  var inboundsPlacements = availablePlacementSpace.filter(function (_a) {
    var w = _a.width,
        h = _a.height;
    return w >= childRect.width && h >= childRect.height;
  }); // If current placement fits use it.

  if (inboundsPlacements.find(function (p) {
    return p.placement === placement;
  }) || !autoFlip) {
    newPlacement = placement;
  } else {
    // Take the direction with the most space
    newPlacement = inboundsPlacements.length ? inboundsPlacements[0].placement : availablePlacementSpace[0].placement;
  }

  var position = {
    top: {
      top: popoutRect.top - childRect.height,
      left: popoutRect.left + popoutRect.width / 2
    },
    left: {
      top: popoutRect.top + popoutRect.height / 2,
      left: popoutRect.left - (childRect.width + pipSize)
    },
    right: {
      top: popoutRect.top + popoutRect.height / 2,
      left: popoutRect.left + popoutRect.width
    },
    bottom: {
      top: popoutRect.bottom,
      left: popoutRect.left + popoutRect.width / 2
    }
  };
  return {
    newPosition: position,
    newPlacement: newPlacement
  };
};

var useStyles = createMemoStyles({
  wrenchHasPopout: __assign(__assign({}, defaultBaseline), {
    position: 'relative',
    display: 'inline-block'
  }),
  wrenchPopoutTrigger: __assign({}, defaultBaseline)
});
var Popout = React.forwardRef(function (_a, ref) {
  var _b = _a.autoClose,
      autoClose = _b === void 0 ? false : _b,
      _c = _a.autoFlip,
      autoFlip = _c === void 0 ? false : _c,
      children = _a.children,
      _d = _a.clickable,
      clickable = _d === void 0 ? false : _d,
      _e = _a.closeButtonLabel,
      closeButtonLabel = _e === void 0 ? 'Close Popout' : _e,
      _f = _a.delay,
      delay = _f === void 0 ? false : _f,
      _g = _a.noCloseButton,
      noCloseButton = _g === void 0 ? false : _g,
      onChange = _a.onChange,
      _h = _a.placement,
      placement = _h === void 0 ? 'top' : _h,
      renderTo = _a.renderTo,
      _j = _a.show,
      show = _j === void 0 ? false : _j,
      _k = _a.size,
      size = _k === void 0 ? 'sm' : _k,
      title = _a.title,
      trigger = _a.trigger,
      elevation = _a.elevation,
      rest = __rest(_a, ["autoClose", "autoFlip", "children", "clickable", "closeButtonLabel", "delay", "noCloseButton", "onChange", "placement", "renderTo", "show", "size", "title", "trigger", "elevation"]);

  var theme = useTheme();

  var _l = useStyles(),
      wrenchHasPopout = _l.wrenchHasPopout,
      wrenchPopoutTrigger = _l.wrenchPopoutTrigger; // Used for placement and popout Style
  //  States


  var _m = useState(show),
      showState = _m[0],
      setShowState = _m[1];

  var _o = useState(),
      popoutStyle = _o[0],
      setPopoutStyle = _o[1];

  var _p = useState(placement),
      placementState = _p[0],
      setPlacementState = _p[1]; // Track timeout through events for delay functionality.


  var timeoutRef = useRef({
    timeout: undefined
  });
  var popoutRef = useRef(null);
  var contentRef = useRef(null); // Update Placement and Style

  useEffect(function () {
    var _a, _b;

    var state = {
      placementState: placement,
      popoutStyle: popoutStyle
    };
    var popoutRect = (_a = popoutRef === null || popoutRef === void 0 ? void 0 : popoutRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    var childRect = (_b = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) === null || _b === void 0 ? void 0 : _b.childBoundingBox;

    if (isBrowser) {
      var width = document.documentElement.clientWidth;
      var height = document.documentElement.clientHeight;
      var pipSize = 12 + theme.spacing[1];
      var renderToZIndex = (elevation !== null && elevation !== void 0 ? elevation : theme.elevation.space) + 1;

      if (childRect && popoutRect) {
        var _c = getNewPosition({
          width: width,
          height: height,
          childRect: childRect,
          popoutRect: popoutRect,
          placement: placement,
          autoFlip: autoFlip,
          pipSize: pipSize
        }),
            newPosition = _c.newPosition,
            newPlacement = _c.newPlacement;

        if (autoFlip) state.placementState = newPlacement;

        if (renderTo) {
          var newPos = newPosition[autoFlip ? newPlacement : placement];
          state.popoutStyle = {
            // Rendering happens relative to the RenderTo
            top: newPos.top,
            left: newPos.left,
            zIndex: renderToZIndex,
            position: 'fixed'
          };
        }
      }

      setPlacementState(state.placementState);
      setPopoutStyle(state.popoutStyle);
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [placement, autoFlip, renderTo, // eslint-disable-next-line react-hooks/exhaustive-deps
  JSON.stringify(contentRef), showState, show]); /// /////////////////// HANDLERS ///////////////////

  useEffect(function () {
    setShowState(show);
  }, [show]); /// /////////////////// HANDLE SCROLL ///////////////////

  var handleScroll = function () {};

  var addScroll = function () {
    if (renderTo && isBrowser) {
      window.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleScroll);
      window.addEventListener('orientationchange', handleScroll);
    }
  };

  var removeScroll = function () {
    if (renderTo && isBrowser) {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
      window.removeEventListener('orientationchange', handleScroll);
    }
  }; /// /////////////////// HANDLE CLICK ///////////////////


  var handleClick = function () {
    if (clickable) {
      if (onChange) onChange(!showState);
      setShowState(!showState);
    }
  }; /// /////////////////// HANDLE MOUSE ///////////////////


  var onMouseEnter = function () {
    if (!clickable) {
      if (delay) {
        timeoutRef.current.timeout = setTimeout( // eslint-disable-next-line func-names
        function () {
          addScroll();
          setShowState(true);
          if (onChange) onChange(true);
        }, 800);
        return;
      }

      addScroll();
      setShowState(true);
      if (onChange) onChange(true);
    }
  };

  var onMouseLeave = function () {
    if (delay && timeoutRef.current.timeout) {
      clearTimeout(timeoutRef.current.timeout);
    }

    if (!clickable) {
      removeScroll();
      setShowState(false);
      if (onChange) onChange(false);
    }
  }; /// /////////////////// HANDLE CLOSE ///////////////////


  var handleClose = function () {
    if (onChange) onChange(false);
    setShowState(false);
    removeScroll();
  };

  var handleAutoCloseBlur = function (e) {
    var _a;

    if ((_a = popoutRef === null || popoutRef === void 0 ? void 0 : popoutRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
      return;
    }

    handleClose();
  }; // componentWillMount


  useEffect(function () {
    if (autoClose && isBrowser) {
      document.addEventListener('mousedown', handleAutoCloseBlur, false);
    } // componentWillUnmount


    return function () {
      if (autoClose && isBrowser) {
        document.removeEventListener('mousedown', handleAutoCloseBlur, false);
      }
    };
  }); // Only expose handleClose to the parent. This forces users to use the ref the way we intended.

  useImperativeHandle(ref, function () {
    return {
      handleClose: handleClose
    };
  }); /// /////////////////// RENDERING ///////////////////
  // Reduce code duplication by rendering as a fucntion rather than double declaring the whole component

  var renderPopoutContent = function () {
    var popoutContent = React.createElement(PopoutContent, {
      ref: contentRef,
      clickable: clickable,
      closeButtonLabel: closeButtonLabel,
      noCloseButton: noCloseButton,
      hasRenderTo: !!renderTo,
      size: size,
      title: title,
      placement: placementState,
      show: showState,
      handleClose: handleClose,
      popoutStyle: popoutStyle !== null && popoutStyle !== void 0 ? popoutStyle : undefined
    }, children);
    if (renderTo && guardElement(renderTo)) createPortal(popoutContent, renderTo);else if ((renderTo === null || renderTo === void 0 ? void 0 : renderTo.current) && guardElement(renderTo.current)) createPortal(popoutContent, renderTo.current);
    return popoutContent;
  };

  return React.createElement("span", __assign({
    className: wrenchHasPopout,
    onBlur: onMouseLeave,
    ref: popoutRef
  }, safeRest(rest)), React.createElement("span", {
    className: wrenchPopoutTrigger,
    onClick: handleClick,
    onKeyDown: handleClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onFocus: onMouseEnter,
    title: title
  }, trigger, renderPopoutContent()));
});
var PopoutWithNested = withNested(Popout, {
  Body: PopoutBody,
  Footer: PopoutFooter,
  Header: PopoutHeader,
  Masthead: PopoutMasthead
});
export { POPOUT_ALIGNMENS, POPOUT_PLACEMENTS, POPOUT_SIZES, PopoutWithNested as Popout };